import { ShieldAlert } from "lucide-react";

export default function InspectBlocked() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black text-white px-6">
      <ShieldAlert className="h-20 w-20 text-red-500 mb-6 animate-pulse" />

      <h1 className="text-3xl font-bold mb-4 text-center">
        Developer Tools Detected!
      </h1>

      <p className="text-gray-300 text-center max-w-md">
        For security reasons, inspecting or modifying this page is not allowed.
        Please close developer tools to continue using the platform.
      </p>

      <div className="mt-8 bg-red-600/20 border border-red-500 px-6 py-3 rounded-lg text-sm text-red-400">
        Access to this page has been temporarily restricted.
      </div>
    </div>
  );
}
